import { ListboxDesignTokens } from '@primeuix/themes/aura/listbox';

export const listboxTokens: ListboxDesignTokens = {
  root: {
    background: '{form.field.background}',
    disabledBackground: '{form.field.disabled.background}',
    disabledColor: '{form.field.disabled.color}',
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    color: '{form.field.color}',
    shadow: '{form.field.shadow}',
    transitionDuration: '{form.field.transition.duration}',
  },
  list: {
    padding: '{list.padding}',
    gap: '{list.gap}',
    header: {
      padding: '{list.header.padding}',
    },
  },
  option: {
    focusBackground: '{list.option.focus.background}',
    focusColor: '{list.option.focus.color}',
    selectedBackground: '{list.option.selected.background}',
    selectedFocusBackground: '{list.option.selected.focus.background}',
    selectedFocusColor: '{list.option.selected.focus.color}',
    selectedColor: '{list.option.selected.color}',
    color: '{list.option.color}',
    padding: '{list.option.padding}',
    borderRadius: '{list.option.border.radius}',
  },
  optionGroup: {
    background: '{list.option.group.background}',
    color: '{list.option.group.color}',
    fontWeight: '{list.option.group.font.weight}',
    padding: '{list.option.group.padding}',
  },
  checkmark: {
    color: '{list.option.color}',
    gutterStart: '-0.375rem',
    gutterEnd: '0.375rem',
  },
  emptyMessage: {
    padding: '{list.option.padding}',
  },
  colorScheme: {
    light: {
      option: {
        stripedBackground: '{surface.50}',
      },
    },
    dark: {
      option: {
        stripedBackground: '{surface.900}',
      },
    },
  },
};
